import { List, Button, Divider, Steps, Breadcrumb, Avatar, Modal, Form, InputNumber } from "antd";
import React, { useState, useEffect } from "react";
import mockTripData from "./mockTripData";
import TripMapOSRM from "./TripMapPlotterOSRM";
import { getTrip, getTripsList } from "mqtt/location";
import { IoCloudUpload, IoReload } from "react-icons/io5";
import { FaRoute, FaTrashCan, FaCar } from "react-icons/fa6";

const CUSTOM_TRIPS_KEY = "customTrips";

const Trip = ({
  loadingUploadingFile,
  loadingSendingTripData,
  messageApi,
  vehicle,
  predefinedPlots,
  customPlotter,
  setCustomPlotter,
  plots,
  sendTripData,
  selectedPlot,
  setSelectedPlot,
  setPlots,
  handleSelectPlot,
  setIntermediateCoordinatesForSelectedRoute,
}) => {
  const [customTrips, setCustomTrips] = useState([]);
  const [customTripIndex, setCustomTripIndex] = useState(-1);
  const [vehicleTripsList, setVehicleTripsList] = useState([]);
  const [selectedTripData, setSelectedTripData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTrip, setEditingTrip] = useState(null);
  const [form] = Form.useForm();

  // Load custom trips from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(CUSTOM_TRIPS_KEY);
    if (stored) {
      setCustomTrips(JSON.parse(stored));
    }
  }, []);

  // Save a new custom trip to localStorage
  const handleSavePlot = () => {
    // The endTime should be the current time when saving
    const tripEndDate = new Date();
    // Subtract number of plots (as minutes) from end time for start time
    const tripStartDate = new Date(
      tripEndDate.getTime() - plots.length * 60 * 1000
    );
    const tripStartTime = tripStartDate.toLocaleString();
    const tripEndTime = tripEndDate.toLocaleString();

    if (!plots || plots.length < 2) return;
    const newTrip = {
      tripId: `CustomTrip-${Date.now()}`,
      startLocation: { coordinates: plots[0], time: tripStartTime },
      places: plots.slice(1, plots.length - 1).map((coords, idx) => ({
        placeId: `Place-${idx + 1}`,
        location: { coordinates: coords },
        time: "", // You can set intermediate times if needed
      })),
      endLocation: { coordinates: plots[plots.length - 1], time: tripEndTime },
      isCustom: true,
      rawPlots: plots,
      drivingDetails: {
        excessSpeed: 0,
        harshBraking: 0,
        rapidAcceleration: 0,
        clutchOverride: 0,
        idleTime: 0,
        gearRpmMismatch: 0
      }
    };
    const updatedTrips = [...customTrips, newTrip];
    setCustomTrips(updatedTrips);
    localStorage.setItem(CUSTOM_TRIPS_KEY, JSON.stringify(updatedTrips));
    setPlots([]);
    setCustomPlotter(false);
  };

  const handleUpdateDistanceInCustomTrip = (distance) =>{
    if(customTripIndex == -1){
      return;
    }
     const updatedTrips = [...customTrips];
     if (updatedTrips[customTripIndex]) {
      updatedTrips[customTripIndex] = {
        ...updatedTrips[customTripIndex],
        distance: distance
      };
      setCustomTrips(updatedTrips);
      localStorage.setItem(CUSTOM_TRIPS_KEY, JSON.stringify(updatedTrips));
    }
    setCustomTripIndex(-1)
  }

  // Select a custom trip and show on map
  const handleSelectCustomTrip = (trip,index) => {
    setSelectedPlot(trip);
    setCustomTripIndex(index);
    setCustomPlotter(false);
    setPlots([]);
  };

  // Delete a custom trip
  const handleDeleteCustomTrip = (tripId) => {
    const updatedTrips = customTrips.filter((t) => t.tripId !== tripId);
    setCustomTrips(updatedTrips);
    localStorage.setItem(CUSTOM_TRIPS_KEY, JSON.stringify(updatedTrips));
    // If the deleted trip is selected, reset selection
    if (selectedPlot?.tripId === tripId) {
      setSelectedPlot(mockTripData[0]);
    }
  };

  const fetchTripsListUsingSerialNo = async (serialNo) => {
    const resp = await getTripsList(serialNo);
    console.log("Fetched trips list:", resp);
    const { data } = resp;
    setVehicleTripsList(data);
  };

  const fetchTripDetailsUsingTripId = async (tripId) => {
    const resp = await getTrip(tripId);
    console.log("Fetched trip details:", resp);
    const { data } = resp;
    setSelectedTripData(data);
  };

  const popEditTripDetails = (trip) => {
    setEditingTrip(trip);
    form.setFieldsValue(trip.drivingDetails);
    setIsModalOpen(true);
  };


  const handleOk = () => {
    form.validateFields()
      .then((values) => {
        const updatedTrips = customTrips.map((trip) => {
          if (trip.tripId === editingTrip.tripId) {
            return {
              ...trip,
              drivingDetails: values
            };
          }
          return trip;
        });

        setCustomTrips(updatedTrips);
        localStorage.setItem(CUSTOM_TRIPS_KEY, JSON.stringify(updatedTrips));

        if (selectedPlot?.tripId === editingTrip.tripId) {
          setSelectedPlot({
            ...selectedPlot,
            drivingDetails: values
          });
        }
        messageApi?.success('Driving details updated successfully');
        setIsModalOpen(false);
        setEditingTrip(null);
        form.resetFields();
      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditingTrip(null);
    form.resetFields();
  };

  useEffect(() => {
    fetchTripsListUsingSerialNo(vehicle.serialNo);
  }, [vehicle.serialNo]);

  return (
    <>
      {/* <TestMap trip={tripMockData} /> */}
      {/* <TripMap
          trip={selectedPlot}
          customPlotter={customPlotter}
          setCustomPlotter={setCustomPlotter}
          plots={plots}
          setPlots={setPlots}
        /> */}
      <TripMapOSRM
        trip={selectedPlot}
        customPlotter={customPlotter}
        setCustomPlotter={setCustomPlotter}
        handleUpdateDistanceInCustomTrip={handleUpdateDistanceInCustomTrip}
        plots={plots}
        setPlots={setPlots}
        setIntermediateCoordinatesForSelectedRoute={
          setIntermediateCoordinatesForSelectedRoute
        }
      />
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            width: "50%",
            marginTop: 16,
            height: 400,
            overflow: "auto",
            padding: "0 16px",
            border: "1px solid rgba(140, 140, 140, 0.35)",
          }}
        >
          <List
            size="small"
            header={
              <div>
                <Breadcrumb separator="›">
                  <Breadcrumb.Item>
                    Trips list for {vehicle?.serialNo}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Button
                      size="small"
                      icon={<IoReload />}
                      iconPosition="end"
                      variant="link"
                      style={{ display: "block", alignItems: "center" }}
                      onClick={() =>
                        fetchTripsListUsingSerialNo(vehicle?.serialNo)
                      }
                    >
                      {"    "}
                      GET {`vehicles/trips?serialno=${vehicle?.serialNo}`}{" "}
                    </Button>
                    {/* <Button>
                      <IoReload />
                    </Button> */}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            }
            // footer={<div>Footer</div>}
            // bordered
            dataSource={vehicleTripsList || predefinedPlots}
            style={{ marginTop: 8, height: "100%" }}
            renderItem={(plot, index) => (
              <List.Item
                style={{
                  borderBottom: "1px solid rgba(140, 140, 140, 0.35)",
                  marginLeft: 0,
                  backgroundColor:
                    selectedPlot?.tripId === plot?.tripId ? "#e6f7ff" : "white",
                }}
                actions={[
                  // <>
                  //   {selectedPlot && selectedPlot?.tripId === plot?.tripId && (
                  //     <Button
                  //       // hidden={selectedPlot?.tripId !== plot?.tripId}
                  //       size="small"
                  //       onClick={() => sendTripData()}
                  //       disabled={
                  //         selectedPlot && selectedPlot?.tripId !== plot?.tripId
                  //       }
                  //     >
                  //       Send Trip Data
                  //     </Button>
                  //   )}
                  // </>,
                  // <Button
                  //   size="small"
                  //   onClick={() => handleSelectPlot(plot)}
                  //   disabled={
                  //     selectedPlot && selectedPlot?.tripId === plot?.tripId
                  //   }
                  // >
                  //   Show on Map
                  // </Button>,
                  <Button
                    className="show-on-map-button"
                    title="Show route on Map"
                    // type="primary"
                    variant="outlined"
                    disabled={
                      selectedPlot && selectedPlot?.tripId === plot?.tripId
                    }
                    onClick={() => {
                      fetchTripDetailsUsingTripId(plot?.tripId);
                      handleSelectPlot(plot);
                    }}
                    icon={<FaRoute />}
                    // href="https://www.google.com"
                    target="_blank"
                  />,
                ]}
              >
                <>
                  <List.Item.Meta
                    avatar={<Avatar>{`${index + 1} `}</Avatar>}
                    title={
                      <a href="">
                        {plot?.tripId}{" "}
                        {/* {`Created : ${new Date(
                          plot?.startTime
                        ).toLocaleString()}`} */}
                      </a>
                    }
                    description={`Start : ${new Date(
                      plot?.startTime
                    ).toLocaleString()} - End : ${new Date(
                      plot?.endTime
                    ).toLocaleString()}`}
                  />
                </>
                {/* <Typography>
                  {`Start : ${new Date(
                    plot?.startTime
                  ).toLocaleString()} - End : ${new Date(
                    plot?.endTime
                  ).toLocaleString()}`}
                </Typography> */}
              </List.Item>
            )}
          />
        </div>
        <div style={{ width: "50%", marginLeft: 16, marginTop: 16 }}>
          <>
            <Button
              // disabled={customPlotter}
              onClick={() => {
                setCustomPlotter(!customPlotter);
                if (customPlotter) {
                  setSelectedPlot(mockTripData[0]);
                  setPlots([]);
                }
              }}
            >
              {customPlotter ? "Cancel" : "Create Custom Trip"}
            </Button>
            {customPlotter && plots && plots?.length > 1 && (
              <Button style={{ marginLeft: "1em" }} onClick={handleSavePlot}>
                Save Plot
              </Button>
            )}
          </>
          {customPlotter ? (
            <>
              {plots && plots.length > 0 && (
                <>
                  <Steps
                    progressDot
                    current={plots.length - 1}
                    direction="vertical"
                    items={plots?.map((plot, index) => {
                      const isFirstPlot = index === 0;
                      const isLastPlot = index === plots.length - 1;
                      if (isFirstPlot) {
                        return {
                          // title: "Trip Start",
                          title: `${plot[0]}, ${plot[1]} (Start)`,
                        };
                      } else if (isLastPlot) {
                        return {
                          // title: "Trip End",
                          title: `${plot[0]}, ${plot[1]} (End)`,
                        };
                      } else {
                        return {
                          // title: `place ${index + 1}`,
                          description: `${plot[0]}, ${plot[1]}`,
                        };
                      }
                    })}
                  />
                </>
              )}
            </>
          ) : (
            <>
              <Modal
                title={`Edit Driving Details - ${editingTrip?.tripId || ''}`}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Update"
                cancelText="Cancel"
                width={500}
              >
                <Form
                  form={form}
                  layout="vertical"
                  name="drivingDetailsForm"
                >
                  <Form.Item
                    label={`Excess Speed (Current: ${editingTrip?.drivingDetails?.excessSpeed || 0})`}
                    name="excessSpeed"
                    rules={[
                      { required: true, message: 'Please input excess speed count' },
                      { type: 'number', message: 'Must be a number' }
                    ]}
                  >
                    <InputNumber 
                      min={0} 
                      precision={0}
                      style={{ width: '100%' }} 
                      controls={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label={`Harsh Braking (Current: ${editingTrip?.drivingDetails?.harshBraking || 0})`}
                    name="harshBraking"
                    rules={[
                      { required: true, message: 'Please input harsh braking count' },
                      { type: 'number', message: 'Must be a number' }
                    ]}
                  >
                    <InputNumber 
                      min={0} 
                      precision={0}
                      style={{ width: '100%' }} 
                      controls={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label={`Rapid Acceleration (Current: ${editingTrip?.drivingDetails?.rapidAcceleration || 0})`}
                    name="rapidAcceleration"
                    rules={[
                      { required: true, message: 'Please input rapid acceleration count' },
                      { type: 'number', message: 'Must be a number' }
                    ]}
                  >
                    <InputNumber 
                      min={0} 
                      precision={0}
                      style={{ width: '100%' }} 
                      controls={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label={`Clutch Override (Current: ${editingTrip?.drivingDetails?.clutchOverride || 0})`}
                    name="clutchOverride"
                    rules={[
                      { required: true, message: 'Please input clutch override count' },
                      { type: 'number', message: 'Must be a number' }
                    ]}
                  >
                    <InputNumber 
                      min={0} 
                      precision={0}
                      style={{ width: '100%' }} 
                      controls={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label={`Idle Time in minutes (Current: ${editingTrip?.drivingDetails?.idleTime || 0})`}
                    name="idleTime"
                    rules={[
                      { required: true, message: 'Please input idle time' },
                      { type: 'number', message: 'Must be a number' }
                    ]}
                  >
                    <InputNumber 
                      min={0} 
                      precision={0}
                      style={{ width: '100%' }} 
                      controls={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label={`Gear RPM Mismatch (Current: ${editingTrip?.drivingDetails?.gearRpmMismatch || 0})`}
                    name="gearRpmMismatch"
                    rules={[
                      { required: true, message: 'Please input gear RPM mismatch count' },
                      { type: 'number', message: 'Must be a number' }
                    ]}
                  >
                    <InputNumber 
                      min={0} 
                      precision={0}
                      style={{ width: '100%' }} 
                      controls={false}
                    />
                  </Form.Item>
                  <Form.Item
                    label={`Distance in meter (Current: ${editingTrip?.distance || 0})`}
                    name="distance"
                    
                    rules={[
                      { type: 'number', message: 'Must be a number' }
                    ]}
                  >
                    <InputNumber 
                      min={0} 
                      precision={0}
                      style={{ width: '100%' }} 
                      controls={false}
                      disabled
                    />
                  </Form.Item>
                </Form>
              </Modal>
              <Divider style={{ margin: "12px 0" }} />
              <List
                size="small"
                header={
                  <div>
                    <Breadcrumb separator="›">
                      <Breadcrumb.Item>Custom Trip</Breadcrumb.Item>
                      <Breadcrumb.Item>PUBLISH TO MQTT TOPIC</Breadcrumb.Item>
                      <Breadcrumb.Item>{`nextdev/vehicles/${vehicle?.serialNo}/info`}</Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                }
                dataSource={customTrips}
                locale={{ emptyText: "No custom trips yet." }}
                renderItem={(trip, tripIndex) => (
                  <List.Item
                    style={{
                      borderBottom: "1px solid rgba(140, 140, 140, 0.15)",
                      backgroundColor:
                        selectedPlot?.tripId === trip?.tripId
                          ? "#e6f7ff"
                          : "white",
                    }}
                    actions={[
                      <Button
                        loading={loadingSendingTripData || loadingUploadingFile}
                        className="publish-trip-button"
                        icon={<IoCloudUpload />}
                        iconPosition="start"
                        // hidden={selectedPlot?.tripId !== plot?.tripId}
                        size="small"
                        onClick={() => sendTripData(trip)}
                        disabled={selectedPlot?.tripId !== trip?.tripId}
                      >
                        Publish to MQTT
                      </Button>,
                      <Button 
                        className="edit-details"
                        title="Edit driving details"
                        variant="outlined"
                        onClick={() => popEditTripDetails(trip)}
                        disabled={selectedPlot?.tripId !== trip?.tripId}
                        icon={<FaCar />}
                      />,
                      <Button
                        className="show-on-map-button"
                        title="Show route on Map"
                        // type="primary"
                        variant="outlined"
                        onClick={() => handleSelectCustomTrip(trip, tripIndex)}
                        disabled={selectedPlot?.tripId === trip?.tripId}
                        icon={<FaRoute />}
                        // href="https://www.google.com"
                        target="_blank"
                      />,
                      <Button
                        danger
                        // type="primary"
                        // variant="outlined"
                        // color="red"
                        onClick={() => handleDeleteCustomTrip(trip.tripId)}
                        icon={<FaTrashCan />}
                        // href="https://www.google.com"
                        target="_blank"
                      />,
                    ]}
                  >
                    {`#${tripIndex + 1} ${trip?.tripId}`}
                  </List.Item>
                )}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Trip;
